module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABAElEQVQ4T53Sz2rCQBAG8G82IIn4BD6AgpQeaq2IXnrx5AvYpqdCwTfSs7aKb+DJgxchVgSRgtJrX6CQfyY7opKQSK3BPe7Ob+GbGcKVh650SA5Xw4xmuhMA0irpxcRQm/XewXhiwpd9rxcSQdXovhGow8y2D1HZPjwvLsLU58etkHJKgCYlWk5Zb+/7coCa0Z0zKCUUpW7eNX/Chq2GGdV0ZwTkAR5YpZdm8HaAqtFbEnDDoLVQxGOAw1yMje06RdRef2MwPe9npS/HBM4FWPpe4zRXdHRhxjjmb4Cyp7n+hPvLKD4WxXOdhSH2vBERseU41Wiuf2HSFbw4x3Mf7QAKyngPDn/FZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloudService/icon_correct.png
// module id = aLKj
// module chunks = 174